var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"setLocale",on:{"click":function($event){return _vm.changeLocale('ru')}}},[_vm._v("RU ")]),_c('span',{staticClass:"setLocale",on:{"click":function($event){return _vm.changeLocale('en')}}},[_vm._v(" EN")])])}
var staticRenderFns = []

export { render, staticRenderFns }